// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'messageStatus.SENDING': 'Sending...',
  'messageStatus.FAILED': 'Send Failed',
  'messageStatus.RETRYING': 'Retrying',
  'messageStatus.DELIVERED': 'Delivered',
};
